import HttpClient from "./httpClient";

export interface Queue {
  id: number;
  name: string;
}

export interface QueuesResponse {
  queues: Queue[];
  msp_type: string;
}

export interface TimeMetrics {
  total_tickets: number;
  open_tickets: number;
  past_due_tickets: number;
  first_response_avg_hours: number;
  first_response_median_hours: number;
  first_response_min_hours: number;
  first_response_max_hours: number;
  tickets_with_first_response: number;
  resolution_avg_hours: number;
  resolution_median_hours: number;
  resolution_min_hours: number;
  resolution_max_hours: number;
  tickets_resolved: number;
  hours_worked_avg: number;
  hours_worked_median: number;
  hours_worked_min: number;
  hours_worked_max: number;
  total_hours_worked: number;
  tickets_with_hours: number;
}

export interface CategoryMetric {
  total_tickets: number;
  open_tickets: number;
  resolved_tickets: number;
  past_due_tickets: number;
  first_response_avg_hours: number;
  first_response_median_hours: number;
  tickets_with_first_response: number;
  resolution_avg_hours: number;
  resolution_median_hours: number;
  hours_worked_avg: number;
  hours_worked_median: number;
  total_hours_worked: number;
  tickets_with_hours: number;
}

export interface QueueAnalytics {
  total_tickets: number;
  tickets_by_account: Record<string, number>;
  tickets_by_priority: Record<string, number>;
  tickets_by_type: Record<string, number>;
  tickets_by_status: Record<string, number>;
  tickets_by_issue_type: Record<string, number>;
  tickets_by_subcategory: Record<string, number>;
  tickets_by_category_and_subcategory: Record<string, number>;
  confidence_breakdown: {
    high: number;
    medium: number;
    low: number;
  };
  time_metrics: TimeMetrics;
  category_metrics: Record<string, CategoryMetric>;
}

export interface ComputeAnalyticsRequest {
  queue_id?: number | null;
  start_date?: string | null;
  end_date: string;
  skip_classification?: boolean;
}

export interface ApiResponse<T> {
  status: 'success' | 'error';
  data: T;
  timestamp: string;
  error?: string;
}

class QueueAnalyticsApi extends HttpClient {
  public getQueues = async (): Promise<QueuesResponse> => {
    const response: ApiResponse<QueuesResponse> = await this.get(`/api/queue-analytics/queues`);
    return response.data;
  };

  public computeAnalytics = async (request: ComputeAnalyticsRequest): Promise<QueueAnalytics> => {
    const response: ApiResponse<QueueAnalytics> = await this.post(`/api/queue-analytics/compute`, {}, request);
    return response.data;
  };
}

export default new QueueAnalyticsApi();

